import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0H1C.4 0 0 .39 0 .977V3.91c0 .587.4.978 1 .978s1-.391 1-.978V1.955h6v13.686H6c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h6c.6 0 1-.39 1-.977s-.4-.978-1-.978h-2V1.955h6V3.91c0 .587.4.978 1 .978s1-.391 1-.978V.978c0-.586-.4-.977-1-.977z"
    }, null, -1)
  ]))]))
}
export default { render: render }